import { ItemType } from '../generated/types'

/** Item Type narrowed to detected */
export type DetectedItemType = ItemType & Required<Pick<ItemType, 'detector'>>

export function isDetectedItemType(itemType?: ItemType): itemType is DetectedItemType {
    return itemType?.generationType === 'detected'
}
